import * as React from "react";
import { Icon } from "sb-resp-ui";

export const renderSportIcon = (sportId: string) =>
    <div className="rj-ev-list__ev-card-icon rj-ev-list__ev-card-icon--sport" data-uat="div-ev-list-ev-card-icon-sport">
        <Icon i={`i-o-sport-${sportId}`} />
    </div>